import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { AuthGuard, SignInGuard, SSORedirectParamsGuard } from '@tripointe/tripointe-cms/services';

const routes: Routes = [
  {
    path: 'sso-login',
    canLoad: [SSORedirectParamsGuard],
    redirectTo: 'auth'
  },
  {
    path: 'auth',
    canLoad: [SignInGuard],
    loadChildren: () => import('@tripointe/tripointe-cms/auth').then(m => m.FeatureAuthModule)
  },
  {
    path: '',
    canLoad: [AuthGuard],
    loadChildren: () =>
      import('@tripointe/tripointe-cms/dashboard').then(m => m.FeatureDashboardModule)
  },
  { path: '**', redirectTo: 'auth' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { onSameUrlNavigation: 'reload' })],
  exports: [RouterModule]
})
export class AppRoutingModule {}
